import * as commonLocal from "./common";
import * as hLocal from "./local_h";
import * as yuanLocal from "./local_yuan";

export const localLangkeyArr = [
  "en.json",
  "zh.json",
  commonLocal.en,
  commonLocal.zh,
  hLocal.en,
  hLocal.zh,
  yuanLocal.en,
  yuanLocal.zh,
];



// WEBPACK FOOTER //
// ./src/assets/i18n/index.ts